import React from 'react';
import { colors } from '../../theme/colors';

const AddFieldSection = ({
  newFieldName,
  setNewFieldName,
  addingField,
  setShowAddFieldSection,
  handleAddSimpleField
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <input
        type="text"
        placeholder="Enter field name..."
        value={newFieldName}
        onChange={(e) => setNewFieldName(e.target.value)}
        style={{
          padding: '0.75rem',
          background: 'rgba(255, 255, 255, 0.05)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          borderRadius: '6px',
          color: '#ffffff',
          fontSize: '0.875rem',
          outline: 'none',
          transition: 'border-color 0.2s',
          '&:focus': {
            borderColor: '#3b82f6'
          }
        }}
        onKeyPress={(e) => {
          if (e.key === 'Enter' && newFieldName.trim() && !addingField) {
            handleAddSimpleField();
          }
        }}
      />
      <div style={{ 
        display: 'flex', 
        gap: '0.75rem', 
        marginTop: '1rem' 
      }}>
        <button
          onClick={() => {
            setShowAddFieldSection(false);
            setNewFieldName('');
          }}
          style={{
            padding: '1rem 1.5rem',
            background: 'transparent',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '6px',
            color: '#a0a0a0',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: 'pointer',
            transition: 'all 0.2s',
            outline: 'none'
          }}
        >
          Cancel
        </button>
        <button
          onClick={handleAddSimpleField}
          disabled={!newFieldName.trim() || addingField}
          style={{
            flex: 1,
            padding: '1rem 1.5rem',
            background: (newFieldName.trim() && !addingField) ? colors.primary : 'rgba(255, 255, 255, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '6px',
            color: (newFieldName.trim() && !addingField) ? '#ffffff' : '#a0a0a0',
            fontSize: '0.875rem',
            fontWeight: '500',
            cursor: (newFieldName.trim() && !addingField) ? 'pointer' : 'not-allowed',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            outline: 'none'
          }}
        >
          {addingField ? 'Saving...' : 'Save'}
        </button>
      </div>
    </div>
  );
};

export default AddFieldSection;
